import { render, staticRenderFns } from "./firm-content.vue?vue&type=template&id=2a7252b9&scoped=true"
import script from "./firm-content.vue?vue&type=script&lang=js"
export * from "./firm-content.vue?vue&type=script&lang=js"
import style0 from "./firm-content.vue?vue&type=style&index=0&id=2a7252b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7252b9",
  null
  
)

export default component.exports